import React from "react";
import styled from "styled-components";

interface JustifyBetweenProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const JustifyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const JustifyBetween: React.FC<JustifyBetweenProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <JustifyContainer className={className} style={style}>
      {children}
    </JustifyContainer>
  );
};

export default JustifyBetween;
